<template>
  <nav class="account__menu-wrap" aria-labelledby="account-navigation">
    <ul class="account__menu">
      <li
        class="account__menu-item"
        v-bind:class="{
          'account__menu-item--active':
            this.$route.name === 'overview' || this.$route.name === 'account',
          'account__menu-item--show': menuOpen,
        }"
      >
        <router-link
          :to="{ name: 'overview' }"
          class="account__menu-item-link"
          v-on:click.native="toggleMenu()"
          >Overview<font-awesome-icon
            icon="caret-down"
            class="account__menu-item-icon"
            :class="{
              'account__menu-item-icon--active':
                this.$route.name === 'overview' ||
                this.$route.name === 'account',
              'account__menu-item--show': menuOpen,
            }"
        /></router-link>
      </li>
      <li
        class="account__menu-item"
        v-bind:class="{
          'account__menu-item--active': this.$route.name === 'plan and billing',
          'account__menu-item--show': menuOpen,
        }"
      >
        <router-link
          :to="{ name: 'plan and billing' }"
          class="account__menu-item-link"
          v-on:click.native="toggleMenu()"
          >Plan and Billing<font-awesome-icon
            icon="caret-down"
            class="account__menu-item-icon"
            :class="{
              'account__menu-item-icon--active':
                this.$route.name === 'plan and billing',
            }"
        /></router-link>
      </li>
      <li
        class="account__menu-item"
        v-bind:class="{
          'account__menu-item--active':
            this.$route.name === 'advanced settings',
          'account__menu-item--show': menuOpen,
        }"
      >
        <router-link
          :to="{ name: 'advanced settings' }"
          class="account__menu-item-link"
          v-on:click.native="toggleMenu()"
          >Advanced Timer Settings<font-awesome-icon
            icon="caret-down"
            class="account__menu-item-icon"
            :class="{
              'account__menu-item-icon--active':
                this.$route.name === 'advanced settings',
            }"
        /></router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "accountMenu",
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    toggleMenu: function() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style></style>
